import { lazyRoute } from "@/routes/lazy-route";

const UnitSettingsPage = lazyRoute(() => import("./unit-settings.page"), "UnitSettingsPage");

export const unitSettingsRoutes = [
  {
    path: "units",
    element: <UnitSettingsPage />,
  },
];
